import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Image, Title} from './../../Basics';

const Particle11 = () => (<div>

  <Title>The idea behind the Cybathlon</Title>

  <Image
    source={require('./cybathlon_DIV_08(1)_cropped.jpg')}
    title='Portrait Robert Riener'
    caption='Robert Riener, Cybathlon initiator. Foto: ETHZ'
  />

  <Paragraph>
    “I came up with the idea of organising a Cybathlon after reading a newspaper article. It described a race
    which involved running up 100 floors in a Chicago high-rise building using a modern motorised leg prosthesis
    functioning like a real leg. The idea of the competition was to present state-of-the-art research in this field.
    I believed we had the capacity to organise such an event in Switzerland, at a larger scale and including more
    disciplines. Why? To promote the development of robotic aids for physically disabled people
    </Paragraph>
    
    <Paragraph>
    <h3>These individuals are often dissatisfied with the currently available prostheses and wheelchairs.</h3>
    </Paragraph>
    
   <Paragraph> 
    The technology is not very advanced and many wheelchairs cannot even negotiate a kerb. Arm prostheses are uncomfortable
    to wear, sometimes cause pressure sores and are often not adapted to performing simple tasks such as opening a small jar.
    Prosthetic legs force their wearers to move asymmetrically, especially when walking uphill, thus damaging their joints.
    Far too often, developers do not consult those depending on these devices in order to learn about their needs. The Cybathlon
    aims to change this state of affairs and to bring the subject to public attention.  
    </Paragraph>
    
    <Paragraph>
    <h3>Hollywood leaves many people with a wrong idea of the situation.</h3>
    </Paragraph>
   
   <Paragraph>
    Take for example the possibilities offered by present-day exoskeletons: unlike what movies show us, the development of such
    support devices for paraplegics is still in a very early stage. During the Cybathlon, we will be seeing the best available
    models. Even the US army is not in possession of anything more advanced. And yet, the short course the participants are required
    to master during the Cybathlon calls for their full strength and concentration.  
   </Paragraph>
   
  <Particle
    number={22}
  />

  <Paragraph>
    It may take another 50 years before the technology is advanced enough to replace a wheelchair and to be of assistance to healthy
    people in their everyday lives by giving them more strength or speed. Then, auxiliary devices such as exoskeletons may appear as
    normal as cars or mobile phones.”
  </Paragraph>

</div>);

export default Particle11;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle11/Particle11_EN.js
 **/